// Top-level routing file for all the single-page app stuff we have
import { ModalLayer } from "common/modals/ModalLayer";
// import stuff that follows the SPA convention
import { routes as adminRoutes } from "features/admin";
import { routes as translationsRoutes } from "features/admin/TMSApp";
import { routes as challengesRoutes } from "features/challenges/ChallengesApp";
import { EventsEmbedConfigurator } from "features/configurators/events-embed";
import { routes as iqRoutes } from "features/connect_iq";
// import stuff that doesn't follow the SPA convention
import { EmbedConfiguratorApp } from "features/embed-configurator";
import { routes as experiencesRoutes } from "features/experiences";
import { routes as goalsRoutes } from "features/goals";
import { routes as homepageRoutes } from "features/homepage";
import { CollectionsPage } from "features/homepage/Collections";
import { CollectionListing } from "features/homepage/Collections/CollectionListing";
import { routes as liveLogsRoutes } from "features/livelogs";
import { routes as newsAndJournalRoutes } from "features/news_and_journal";
import { NotificationsPage } from "features/notifications/NotificationsPage";
import { routes as organizationsRoutes } from "features/organizations";
import { Faq } from "features/pages/Faq";
import { FourOhFour } from "features/pages/FourOhFour";
import { Heatmap } from "features/pages/Heatmap";
import { TrialConfirmationPage } from "features/pages/TrialConfirmationPage";
import { routes as paymentsRoutes } from "features/payments";
import { Planner } from "features/planner/Planner";
import { routes as regionsRoutes } from "features/regions/RegionsApp";
import { routes as rrRoutes } from "features/ride_reports";
import { routes as styleguideRoutes } from "features/styleguide";
import { TourismEmbedConfiguratorApp } from "features/tourism-embed-configurator";
import { routes as trouteShowRoutes } from "features/troute_show";
import { routes as usersRoutes } from "features/users";
import React, { useEffect } from "react";
import { Route, Switch, withRouter } from "react-router-dom";

// alphabetize if possible, subject to `Switch` order considerations
export const Routes = withRouter(({ history }) => {
  useEffect(() => {
    // keep google analytics updated on SPA navigation
    let removeListener;
    if (window.ga) {
      removeListener = history.listen((location) => {
        if (!location) {
          return;
        }
        window.ga("set", "page", location.pathname + location.search);
        window.ga("send", "pageview");
      });
    }
    return () => removeListener();
  }, []);

  return (
    <>
      {/* always render ModalLayer */}
      <Route component={ModalLayer} />

      {/* render only one of these  */}
      <Switch>
        <Route path="/admin">{adminRoutes}</Route>
        <Route path="/challenges">{challengesRoutes}</Route>
        <Route path="/collections/:id" component={CollectionListing} />
        <Route path="/embeds/configure_regional" component={TourismEmbedConfiguratorApp} />
        <Route path="/embeds/configure_events" component={EventsEmbedConfigurator} />
        <Route path="/embeds/new" component={EmbedConfiguratorApp} />
        <Route path="/experiences">{experiencesRoutes}</Route>
        <Route path="/faq" component={Faq} />
        <Route path="/goals">{goalsRoutes}</Route>
        <Route path="/heatmap" component={Heatmap} />
        <Route path="/iq">{iqRoutes}</Route>
        {liveLogsRoutes}
        {newsAndJournalRoutes}
        <Route path="/notifications" component={NotificationsPage} />
        <Route path="/organizations">{organizationsRoutes}</Route>
        <Route path="/regions">{regionsRoutes}</Route>
        <Route path="/ride_reports">{rrRoutes}</Route>
        <Route path="/routes/new" exact component={Planner} />
        <Route path="/routes/:id/edit" component={Planner} />
        {["routes", "trips"].map((path, idx) => (
          <Route path={`/${path}/:trouteId`} key={idx}>
            {trouteShowRoutes}
          </Route>
        ))}
        <Route path="/styleguide">{styleguideRoutes}</Route>
        <Route path="/subscriptions">{paymentsRoutes}</Route>
        <Route path="/tms">{translationsRoutes}</Route>
        <Route path="/trial_confirmed" component={TrialConfirmationPage} />
        <Route path="/users/:userId/collections" component={CollectionsPage} />
        <Route path="/users">{usersRoutes}</Route>
        {/*<Route path="/ui_prototype" component={TSTest} />*/}
        <Route
          exact
          path={[
            "/",
            "/dashboard",
            "/calendar",
            "/routes",
            "/rides",
            "/collections",
            "/analyze",
            "/upload",
            "/feed",
            "/more",
          ]}
        >
          {homepageRoutes}
        </Route>
        <Route path="/*" component={FourOhFour} />
      </Switch>
    </>
  );
});

//   keeping this around as it lets us collect email from users before they get
//   a trial
//   <Route path='/start_trial' component={TrialLandingPage} />
//
